<template>
  <div class="row">
    <div class="col-7 grid-force-newlines">
      <FormRow :label="startDateLabel">
        <FormDate v-model="internalStartDate" @input="updateDates()" />
      </FormRow>
      <FormRow :label="endDateLabel">
        <FormDate v-model="internalEndDate" @input="updateDates()" />
      </FormRow>
    </div>
    <div class="col-5">
      <FormButton class="btn-block btn-default btn-sm" @click="selectDateFilterThisMonth">This Month</FormButton>
      <FormButton class="btn-block btn-default btn-sm" @click="selectDateFilterThisQuarter">This Quarter</FormButton>
      <FormButton class="btn-block btn-default btn-sm" @click="selectDateFilterThisFinYear">This Financial Year</FormButton>
      <FormButton class="btn-block btn-default btn-sm" data-toggle="dropdown"><i class="fas fa-caret-down"></i> More</FormButton>
      <ul class="dropdown-menu dropdown-menu-right">
        <DropdownMenuItem icon="fa-calendar-week" @click="selectDateFilterToday">Today</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-week" @click="selectDateFilterYesterday">Yesterday</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-week" @click="selectDateFilterThisWeek">This Week</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-week" @click="selectDateFilterThisCalYear">This Calendar Year</DropdownMenuItem>
        <DropdownMenuDivider />
        <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterLastWeek">Last Week</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterLastMonth">Last Month</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterLastQuarter">Last Quarter</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterLastFinYear">Last Financial Year</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-minus" @click="selectDateFilterLastCalYear">Last Calendar Year</DropdownMenuItem>
        <DropdownMenuDivider />
        <DropdownMenuItem icon="fa-calendar-alt" @click="selectDateFilterMonthToDate">Month to Date</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-alt" @click="selectDateFilterQuarterToDate">Quarter to Date</DropdownMenuItem>
        <DropdownMenuItem icon="fa-calendar-alt" @click="selectDateFilterYearToDate">Year to Date</DropdownMenuItem>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ReportDateRangeSelect',
  props: {
    startDate: String,
    endDate: String,
    startDateLabel: {
      type: String,
      default: 'Start Date'
    },
    endDateLabel: {
      type: String,
      default: 'End Date'
    }
  },
  watch: {
    startDate: function() {
      this.$data.internalStartDate = this.$props.startDate ? moment(this.$props.startDate).toDate().toISOString() : null
    },
    endDate: function() {
      this.$data.internalEndDate = this.$props.endDate ? moment(this.$props.endDate).toDate().toISOString() : null
    }
  },
  data() {
    return {
      internalStartDate: this.$props.startDate ? moment(this.$props.startDate).toDate().toISOString() : null,
      internalEndDate: this.$props.endDate ? moment(this.$props.endDate).toDate().toISOString() : null
    }
  },
  methods: {
    selectDateFilterToday() {
      this.internalStartDate = moment().local().startOf('day').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('day').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterYesterday() {
      this.internalStartDate = moment().local().subtract(1, 'day').startOf('day').toDate().toISOString()
      this.internalEndDate = moment().local().subtract(1, 'day').endOf('day').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterThisWeek() {
      this.internalStartDate = moment().local().startOf('week').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('week').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterThisMonth() {
      this.internalStartDate = moment().local().startOf('month').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('month').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterThisQuarter() {
      this.internalStartDate = moment().local().startOf('quarter').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('quarter').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterThisFinYear() {
      var quarterStart = moment().local().startOf('quarter')
      var curQtr = quarterStart.quarter()
      if(curQtr == 4)
        quarterStart = quarterStart.quarter(3)
      else if(curQtr <= 2)
        quarterStart = quarterStart.subtract(1, 'year').quarter(3)

      this.internalStartDate = quarterStart.startOf('quarter').toDate().toISOString()
      this.internalEndDate = quarterStart.clone().add(1, 'year').subtract(1, 'day').endOf('quarter').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterThisCalYear() {
      this.internalStartDate = moment().local().startOf('year').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('year').toDate().toISOString()

      this.updateDates()
    },

    selectDateFilterLastWeek() {
      this.internalStartDate = moment().local().subtract(1, 'week').startOf('week').toDate().toISOString()
      this.internalEndDate = moment().local().subtract(1, 'week').endOf('week').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterLastMonth() {
      this.internalStartDate = moment().local().subtract(1, 'month').startOf('month').toDate().toISOString()
      this.internalEndDate = moment().local().subtract(1, 'month').endOf('month').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterLastQuarter() {
      this.internalStartDate = moment().local().subtract(1, 'quarters').startOf('quarters').toDate().toISOString()
      this.internalEndDate = moment().local().subtract(1, 'quarters').endOf('quarters').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterLastFinYear() {
      var quarterStart = moment().local().startOf('quarter')
      var curQtr = quarterStart.quarter()
      if(curQtr == 4)
        quarterStart = quarterStart.quarter(3)
      else if(curQtr <= 2)
        quarterStart = quarterStart.subtract(1, 'year').quarter(3)

      var finStart = quarterStart.startOf('quarter')
      var finEnd = quarterStart.clone().add(1, 'year').subtract(1, 'day').endOf('quarter')

      finStart.subtract(1, 'year')
      finEnd.subtract(1, 'year')

      this.internalStartDate = finStart.toDate().toISOString()
      this.internalEndDate = finEnd.toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterLastCalYear() {
      this.internalStartDate = moment().local().subtract(1, 'year').startOf('year').toDate().toISOString()
      this.internalEndDate = moment().local().subtract(1, 'year').endOf('year').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterMonthToDate() {
      this.internalStartDate = moment().local().startOf('month').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('day').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterQuarterToDate() {
      this.internalStartDate = moment().local().startOf('quarter').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('day').toDate().toISOString()

      this.updateDates()
    },
    selectDateFilterYearToDate() {
      this.internalStartDate = moment().local().startOf('year').toDate().toISOString()
      this.internalEndDate = moment().local().endOf('day').toDate().toISOString()

      this.updateDates()
    },

    updateDates() {
      // Ensure the start & end dates are start/end of the day respectively timewise for the local timezone of the browser
      // Fixes issues with reporting (ie, charts) not displaying correct data due to timestamps cutting off data during the day
      if(this.internalStartDate)
        this.internalStartDate = moment(this.internalStartDate).local().startOf('day').toDate().toISOString()
      if(this.internalEndDate)
        this.internalEndDate = moment(this.internalEndDate).local().endOf('day').toDate().toISOString()

      this.$emit('updateStartDate', this.internalStartDate)
      this.$emit('updateEndDate', this.internalEndDate)
    }
  }
}
</script>